import List from 'containers/CompanyRequests/List';
import Edit from 'containers/CompanyRequests/Edit';
import Create from 'containers/CompanyRequests/Create';
import Show from 'containers/CompanyRequests/Show';

export default { List, Edit, Create, Show };
